import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'; 
import cl from './ImageModal.module.css'
import ImageIcon from "../../../../assets/Icon/ImageIcon";
import ImageUploader from '../../../UI/ImageUploader/ImageUploader';
import automobyApi from '../../../../Api';
import { useAuth } from '../../../../providers/authProvider';
import { AppContext } from '../../../../providers/appProvider';

const CargoImageModal = ({ containerService, defaultCargo, disabled }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loadingImages, setLoadingImages] = useState([])
    const [arrivalImages, setArrivalImages] = useState([]) 
    const {session} = useAuth(AppContext)
  
    useEffect(() => { 
        setLoadingImages(defaultCargo.images_obj.loading) 
        setArrivalImages(defaultCargo.images_obj.arrival)  
    }, [])

    const uploadImage = async (kind, acceptedFiles) => {
     
        const formData = new FormData();

        acceptedFiles.forEach((file) => {
            formData.append('images[]', file, file.name);
        });

        formData.append('cargoid', defaultCargo.id.toString());
        formData.append('kind', kind);

        try {

            const response = await automobyApi.post("/cargo/image/upload", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            setLoadingImages(response.data.loading)
            setArrivalImages(response.data.arrival)
             containerService.fetchList()
        } catch (error) {
            console.error('Error during file upload:', error);
            throw error;
        }
    }

    const deleteImage = async (kind, image) => {
       
        const requestData = {
            cargo_id: defaultCargo.id,
            kind: kind,
            image: image
        };
 
        try {
            const response = await automobyApi.post("/cargo/image/delete", requestData)

            setLoadingImages(response.data.loading)
            setArrivalImages(response.data.arrival)
 
        } catch (error) {
            console.error('Error during file upload:', error);
            throw error;
        }
    }
 
    const downloadImage = (name) => {
        containerService.downloadCargoFile(defaultCargo.id, name)
    }
  
    return (
        <>         

        {defaultCargo.images_obj.loading == '' && defaultCargo.images_obj.arrival == '' ? (
            <span className={cl.BtnCargo} onClick={() => setIsModalOpen(true)}  >
                <ImageIcon/> 
            </span>
        ) : (
            <span className={cl.BtnCargo + ' '+ cl.BtnCargoGreen} onClick={() => setIsModalOpen(true)}  >
                <ImageIcon/> 
            </span> 
        )}
    

 

            <Modal size="large" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.EditBtn} ><ImageIcon /></span> სურათები
                    </h3>
                </div>

                <div style={{ position: 'relative', display: 'block' }}> 
                    <div className={ cl.threeBox }>
 
                        <div className={ cl.col }>
                            <span className={ cl.downBTN } onClick={() => downloadImage("loading")}> გადმოწერა</span>

                            <ImageUploader images={loadingImages}
                            uploadImage={uploadImage}
                            deleteImage={deleteImage}
                            title="ჩატვირთვის სურათები" 
                            kind="loading"
                            disabled={disabled}
                                                        ></ImageUploader> 
                        </div>
                        
                        <div className={ cl.col }>
                            
                            <span className={ cl.downBTN } onClick={() => downloadImage("arrival")}> გადმოწერა</span>

                            <ImageUploader 
                                images={arrivalImages}
                                uploadImage={uploadImage}
                                deleteImage={deleteImage}
                                title="გადმოტვირთვის სურათები" 
                                kind="arrival"
                                disabled={disabled}
                                > 
                            </ImageUploader>
                        </div>
                        
                    
                        
                    </div>
                </div>

            </Modal>


        </>
    );
};

export default CargoImageModal;